export const styles = {
  container: (isMobile, menuOpen) => ({
    width: isMobile ? "100vw" : "28%",
    borderRight: isMobile ? "none" : "1px solid #e5e7eb",
    padding: isMobile ? "8px" : "16px",
    backgroundColor: "#ffffff",
    height: "100vh",
    maxHeight: "100vh",

    display: "flex",
    flexDirection: "column",
    transition: "all 0.3s ease",
    display: isMobile ? (menuOpen ? "flex" : "none") : "flex"
  }),

  h2: (isMobile) => ({
    margin: 0,
    color: "#111827",
    fontSize: isMobile ? "16px" : "18px",
    fontWeight: "600",
  }),

  searchContainer: (isMobile) => ({
    position: "relative",
    margin: isMobile ? "8px 3%" : "16px 0",
  }),

  input: (isMobile) => ({
    width: "100%",
    height: isMobile ? "25px" : "40px",
    padding: isMobile ? "4px 4px 4px 25px" : "10px 10px 10px 40px",
    borderRadius: "20px",
    outline: "none",
    boxSizing: "border-box",
    border: "none",
    fontSize: isMobile ? "10px" : "16px",
    backgroundColor: "#f9fafb",
    transition: "all 0.2s ease",
    marginRight: "5%"
  }),

   
  svg: (isMobile) => ({
    position: "absolute",
    left: !isMobile ? "12px" : "0px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "20px",
    height: "20px",
    fill: "#9ca3af",
  }),

  ul: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    flex: 1,
    overflowY: "auto"
  },

  li: (isMobile, active) => ({
    display: "flex",
    alignItems: "center",
     marginRight: "5%",
    padding: isMobile ? "8px" : "10px",
    cursor: "pointer",
    borderRadius: "12px",
    marginBottom: "6px",
    backgroundColor: active ? "#eef2ff" : "transparent",
    transition: "all 0.2s ease",
  }),

  img: (isMobile) => ({
    width: isMobile ? "34px" : "40px",
    height: isMobile ? "34px" : "40px",
    borderRadius: "50%",
    marginRight: "10px",
    objectFit: "cover",
  }),

  name: (isMobile) => ({
    fontWeight: "600",
    color: "#111827",
    fontSize: isMobile ? "13px" : "14px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),

  lastMessage: (isMobile) => ({
    fontSize: isMobile ? "12px" : "13px",
    color: "#6b7280",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: 2,
  }),

  time: (isMobile) => ({
    fontSize: "11px",
    color: "#9ca3af",
    marginLeft: "auto",
    flexShrink: 0,
  }),

  badge: {
    backgroundColor: "#2563eb",
    color: "#fff",
    fontSize: "10px",
    borderRadius: "999px",
    padding: "2px 6px",
    marginLeft: 6,
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255,255,255,0.6)",
    zIndex: 999,
  },

  spinner: {
    width: 45,
    height: 45,
    border: "4px solid #e5e7eb",
    borderTop: "4px solid rgb(31, 58, 112)",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
    padding: "3%"
  },

  addButton: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: "none",
    background: "rgb(31, 58, 112)",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  emptyState: {
    textAlign: "center",
    marginTop: 40,
    color: "#9ca3af",
    fontSize: 14,
  },

  loadingMoreContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 12,
    color: "#6b7280",
    fontSize: 13,
},

spinnerSmall: {
    width: 16,
    height: 16,
    border: "2px solid #e5e7eb",
    borderTop: "2px solid #2563eb",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
}
};